import { isValid, format } from 'date-fns';
import { toUTC } from '../../../utils/DateUtils';
import { getDateFnsLocale } from '../../../extensions/date-fns';
export default function formatDate(value) {
  if (value == null) {
    return null;
  }
  const utcDate = toUTC(new Date(value));
  if (!isValid(utcDate)) {
    return null;
  }
  return format(utcDate, 'PP', {
    locale: getDateFnsLocale()
  });
}